<template>
  <b-col>
    <b-card
      v-if="!id"
      sub-title="Moje pohľadničky s motívom kvetov"
      header="Kvietky"
      text-variant="dark"
    >
      <b-row>
        <b-col
          v-for="(item, index) in data"
          :key="index"
          deck
          sm="12"
          md="6"
          lg="4"
          style="margin-top:5px"
        >
          <postcard
            :source-pictutes="data[index].pictutes"
            :title-img="data[index].title"
            :details-img="data[index].details"
            :size-img="data[index].size"
            :material-img="data[index].material"
            :kind-img="data[index].img"
            :path-img="/kvietky/ + data[index].id"
          />
        </b-col>
      </b-row>
    </b-card>
    <router-view/>
  </b-col>
</template>

<script>
import Picture from "./Picture"
import { ref, watch } from "@vue/composition-api"
export default {
  name: 'Kvietky',
  components: {
    'postcard': Picture
  },
  setup(params, context) {
    const id = ref(false)
    if (context.root.$route.params.id) {
      id.value = true
    }
    watch(() => context.root.$route.params.id, (value) => { value ? id.value = true : id.value = false })
    const data = ref([
      {
        pictutes: ['/static/images/kvietky/kvietky11.jpg','/static/images/kvietky/kvietky12.jpg'],
        title: "Orgován - 5,30 €",
        subtitle: "Pohľadnica",
        details: "...už kvitnú a rozvoniavajú :) ...krásna jarná pohľadnička s motívom orgovánu, ktorý som vytvorila technikou decoupage, ručne vyrezala a nalepila v 3D efekte na biely pohľadnicový základ, pohľadnička je previazaná fialovobielou šnúrkou. Ku pohľadničke posielam ručne robenú obálku na mieru.",
        size: "...14,5 x 10,5 cm",
        material: "obyčajný papier, špagát, kartón",
        kind: "decoupage, cardmaking, lepenie",
        id: 5
      },
      {
        pictutes: ['/static/images/kvietky/kvietky1.jpg','/static/images/kvietky/kvietky2.jpg'],
        title: "Snežienky - 5,40 €",
        subtitle: "Pohľadnica",
        details: "...veľmi jemná, minimalistická pohľadnička so snežienkami, ktoré akoby práve vykúkali spod snehovej prikrývky :) Snežienky som vyrobila technikou decoupage, ručne vyrezala a nalepila na biely pohľadnicový základ v 3D efekte. Posielam s ručne robenou obálkou na mieru. Pohľadnička sa otvára zdola.",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, kartón",
        kind: "decoupage, cardmaking, lepenie",
        id: 4
      },
      {
        pictutes: ['/static/images/kvietky/kvietky3.jpg','/static/images/kvietky/kvietky4.jpg','/static/images/kvietky/kvietky5.jpg'],
        title: "Rozkvitnutá halúzka - 3,60 €",
        subtitle: "Pohľadnica",
        details: "..otváracia pohľadnica s jemným kvetinovým motívom, ktorý bol vytvorený technikou decoupage, nalepený v 3D efekte na biely ručne robený pohľadnicový základ, pohľadnica je bez textov, na voľno previazaný maslovým motúzikom. Posielam s ručne robenou obálkou. Môžete ju poslať ako veľkonočný pozdrav, poslúži aj ako narodeninové prianie, či pozdrav k meninám :)",
        size: "14,5 x 10,5 cm",
        material: "obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 3
      },
      {
        pictutes: ['/static/images/kvietky/kvietky6.jpg','/static/images/kvietky/kvietky7.jpg'],
        title: "Už kvitne - 3,60 €",
        subtitle: "Pohľadnica",
        details: "..otváracia pohľadnica s jemným kvetinovým motívom, ktorý bol vytvorený technikou decoupage, nalepený v 3D efekte na biely ručne robený pohľadnicový základ, pohľadnica je bez textov, na voľno previazaný tmavošedým motúzikom. Posielam s ručne robenou obálkou. Môžete ju poslať ako veľkonočný pozdrav, poslúži aj ako narodeninové prianie, či pozdrav k meninám :)",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 2
      },
      {
        pictutes: ['/static/images/kvietky/kvietky8.jpg','/static/images/kvietky/kvietky9.jpg','/static/images/kvietky/kvietky10.jpg'],
        title: "Ruža - 5,40 €",
        subtitle: "Pohľadnica",
        details: "...otváracia pohľadnička s motívom ružičky v plnom kvete, tú som vytvorila technikou decoupage, ručne vyrezala a nalepila v 3D efekte a prizdobila bielou ľanovou šnúrkou. Posielam s pevnou ručne robenou obálkou. ",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 1
      }
    ])
    return {
      data,
      id
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Kvietky.vue